import {Navigate} from 'react-router';

import { LOGIN } from '../../constants/routes';

const Home = () => {
  return <Navigate replace to={LOGIN} />;
};

export default Home;
